import Flag from '@/app/component/atom/flag'

export const formatPhoneNumber = (contactId: number, countryCode: string, phoneNumber?: string | null) => (
  <>
    <Flag code={countryCode} /> {phoneNumber ? ` +${phoneNumber}` : `Contact ID: ${contactId}`}
  </>
)
